import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import layout from 'core/redux/reducers/layout';
import { WPContent } from './WPContent';
import { user } from './user';
import { modals } from './modals';
import { userApplications } from './userApplications';
import { priceList } from './priceList';
import { settingsApplication } from './settingsApplication';

const createRootReducer = (history: History) => combineReducers({
  router: connectRouter(history),
  layout,
  WPContent,
  user,
  modals,
  userApplications,
  priceList,
  settingsApplication,
});

export default createRootReducer;
